@defer (when isLoading === true) {
    @if (!team?.participants?.length) {
        <app-empty-page class="content-width" *ngIf="" text="{{'There are not any player on this team' | translate}}" iconName="people"></app-empty-page>
    } @else {
        <ion-list class="content-width">
            @for (p of team?.participants; track $index) {
                <ion-item-sliding #slidingItem>
                    <ion-item button (click)="goToProfilePage(p)">
                        <ion-avatar slot="start" *ngIf="p.person?.profile_image">
                        <img style="width: auto" [src]="p.person?.profile_image" />
                        </ion-avatar>
                        <ion-avatar slot="start" *ngIf="!p.person?.profile_image">
                        <img class="avatarImage" [src]="avatarImage" />
                        </ion-avatar>
                    
                        <ion-label>
                        {{ p.person.first_name }} {{ p.person.last_name }}
                        <p>{{ getUserSex(p.person) }}</p>
                        </ion-label>
                    </ion-item>
                    @if (isOwner && 
                    !['ITA', 'USTA'].includes(team?.organisations[0]?.organisationAbbreviation) && 
                    !['ITA', 'USTA'].includes(team?.organisation?.organisationAbbreviation)) {
                            <ion-item-options side="end">
                                <ion-item-option (click)="removePlayer(p.person._id, slidingItem)" color="danger">{{ 'Remove' | translate }}</ion-item-option>
                            </ion-item-options>
                    }
                </ion-item-sliding>
            }
        </ion-list>
    }

    @if (((isOwner && team?.authentication?.status) || isOfficial) && team.organisations?.length) {
        <ion-button (click)="synchronizeRoster()" fill="clear" expand="block">
            <ion-icon slot="start" name="sync-outline"></ion-icon>
            Synchronize Roster
        </ion-button>
    }
} @loading(minimum 0.6s) {
    <div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    </div>
}